import React, { Fragment, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import GooglePlacesAutocomplete, { geocodeByPlaceId } from 'react-google-places-autocomplete';
import { ReactComponent as SearchIcon } from 'feather-icons/dist/icons/search.svg';
import { ReactComponent as LoaderIcon } from 'feather-icons/dist/icons/loader.svg';
import 'react-google-places-autocomplete/dist/assets/index.css';

const AutocompletePlacesField = ({ onSelect, _ }) => {
  const [loading, setLoading] = useState(false);
  const countryCode = useSelector(state => state?.global?.countryCode);

  const searchPlace = useCallback(
    place => {
      setLoading(true);

      geocodeByPlaceId(place.place_id)
        .then(results => {
          setLoading(false);

          if (results) {
            const geometry = results[0]?.geometry?.location;

            if (geometry) {
              onSelect(geometry.toJSON());
            }
          }
        })
        .catch(_ => {
          setLoading(false);
        });
    },
    [onSelect],
  );

  return (
    <Fragment>
      <GooglePlacesAutocomplete
        onSelect={searchPlace}
        placeholder="Buscar lugar"
        renderInput={props => (
          <div className="custom-wrapper relative">
            <span className="absolute pt-2 pl-2">{loading ? <LoaderIcon /> : <SearchIcon />}</span>
            <input
              disabled={loading}
              className="border-gray-300 border-solid border py-2 pr-4 pl-10 w-full text-lg"
              style={{ opacity: loading ? 0.8 : 1 }}
              {...props}
            />
          </div>
        )}
        autocompletionRequest={{
          componentRestrictions: {
            country: countryCode || 'sv',
          },
        }}
      />
    </Fragment>
  );
};

export default AutocompletePlacesField;
